import _Typography from "@mui/material/Typography";
import _Box from "@mui/material/Box";
import React from 'react';
import { useTranslation } from 'react-i18next';
export function RoadTypeLegend({
  entries
}) {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: 1
  }, entries.map(({
    key,
    color,
    labelKey
  }) => /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 1,
    key: key
  }, /*#__PURE__*/React.createElement(_Box, {
    borderRadius: 4,
    height: 8,
    sx: {
      backgroundColor: color
    },
    width: 8
  }), /*#__PURE__*/React.createElement(_Typography, {
    variant: "body2"
  }, t(labelKey)))));
}